// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import lang from 'quasar/lang/zh-hans.js';

import Vue from 'vue';

import './styles/quasar.scss';
import 'quasar/dist/quasar.ie.polyfills';
import '@quasar/extras/material-icons/material-icons.css';
import {Dialog, Notify, Quasar} from 'quasar';

Vue.use(Quasar, {
    config: {},
    components: { /* not needed if importStrategy is not 'manual' */},
    directives: { /* not needed if importStrategy is not 'manual' */},
    plugins: {Notify, Dialog},
    lang: lang,
});
